function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Monitor"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 29,
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  className: "iconic-monitor-screen iconic-monitor-screen-border iconic-property-stroke",
  fill: "none",
  d: "M1 1h30v20h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 28.5v-.5c-.552 0-1-.448-1-1v-4h-6v4c0 .552-.448 1-1 1v.5h8z",
  className: "iconic-monitor-base iconic-monitor-base-neck iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 28h-12c-.552 0-1 .448-1 1h14c0-.552-.448-1-1-1z",
  className: "iconic-monitor-base iconic-monitor-base-foot iconic-property-fill"
}));

function SvgMonitorMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "monitor",
    className: "iconic iconic-monitor iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMd);
export default __webpack_public_path__ + "static/media/monitor-md.27dab041.svg";
export { ForwardRef as ReactComponent };